import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=c48b392a&scoped=true"
import script from "./SelectView.vue?vue&type=script&lang=js"
export * from "./SelectView.vue?vue&type=script&lang=js"
import style0 from "./SelectView.vue?vue&type=style&index=0&id=c48b392a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48b392a",
  null
  
)

export default component.exports